import { customType } from 'drizzle-orm/pg-core/columns/custom';

export const bytea = customType<{ data: string; driverData: string | Buffer; notNull: false; default: false }>({
  dataType() {
    return 'bytea';
  },
  fromDriver(value) {
    return value.toString().replace('\\x', '');
  },
});

export const byteaAsBuffer = customType<{ data: Buffer; driverData: Buffer; notNull: false; default: false }>({
  dataType() {
    return 'bytea';
  },
});

export const byteaAsHexString = customType<{
  data: string;
  driverData: string | Buffer;
  notNull: false;
  default: false;
}>({
  dataType() {
    return 'bytea';
  },
  fromDriver(value) {
    return value.toString('hex').replace('\\x', '');
  },
  toDriver(value) {
    return Buffer.from(value, 'hex');
  },
});
